/** @jsx jsx */
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, Flex, jsx } from 'theme-ui'
import { useCart } from '@chordcommerce/gatsby-theme-autonomy'
import { useEmptyCart } from '~/hooks/components/use-empty-cart'
import { useAria } from '~/hooks/components/use-aria'
import { applyPromoCodesFromStorage } from '~/hooks/components/use-promo-codes'
import QuantityIncrementor from '~/components/Generic/QuantityIncrementor'

const CartQuantitySelector = ({
  disableChange,
  quantity,
  lineItemId,
  ...props
}) => {
  const { updateAriaLive } = useAria()
  const { addPromoCode, modifyLineItem, removeFromCart } = useCart()
  const { emptyClubCart } = useEmptyCart()
  const [isLoading, setIsLoading] = useState(false)

  const updateQuantity = async (quantity) => {
    setIsLoading(true)

    // If the club cart persists and a product gets removed, remove them all.
    await emptyClubCart(true)

    const intQuantity = parseInt(quantity)

    try {
      if (intQuantity === 0) {
        await removeFromCart({ lineItemId })
        updateAriaLive('Product removed from cart.')
      } else {
        await modifyLineItem({
          lineItemId,
          attributes: { quantity: intQuantity },
        })
      }

      try {
        applyPromoCodesFromStorage({ addPromoCode })
      } catch (error) {}
    } catch (error) {}
  }

  useEffect(() => {
    setIsLoading(false)
    updateAriaLive(`Quantity changed to ${quantity}.`)
  }, [quantity, lineItemId, updateAriaLive])

  return (
    <Flex
      mt="4px"
      sx={{ alignItems: 'center', justifyContent: 'space-between' }}
    >
      <Button
        variant="reset"
        onClick={() => updateQuantity(0)}
        aria-label="Remove product from cart"
        sx={{
          variant: 'text.body3',
          color: 'brandPrimary',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        {'Remove'}
      </Button>
      <QuantityIncrementor
        disableChange={disableChange}
        quantity={quantity}
        handleChange={updateQuantity}
        isLoading={isLoading}
      />
    </Flex>
  )
}

CartQuantitySelector.propTypes = {
  lineItemId: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
}

export default CartQuantitySelector
